// src/components/Login.js
import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLoginMutation, useResetPasswordMutation } from '../../redux/services/authApi';
import { useTranslation } from 'react-i18next';
import headerImage from "../../assets/images/MysticTan_Unity_Logo_Black.png"
// import "../../assets/css/unityIcon.css"
import "./login.css"
import { use } from 'react';
const Login = () => {
  const { t } = useTranslation("translation", { keyPrefix: "login" });
  const user = useSelector((state) => state?.auth?.user)
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [login, { isLoading, isSuccess, error }] = useLoginMutation();
  const [forgor, { isLoading:forgorLoading, isSuccess:forgorSuccess, isError:forgerror }] = useResetPasswordMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lastTried, setLastTried] = useState("none")

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLastTried("login")
    try {
      const result = await login({ email, password }).unwrap();
      // dispatch(setUser(result));
    } catch (err) {
      console.error('Login failed:', err);
    }
  };

  const handleForgor = async (e) => {
    e.preventDefault();
    setLastTried("forgor")
    try {
      const result = await forgor({ email, password }).unwrap();
      // dispatch(setUser(result));
    } catch (err) {
      console.error('passwordReset failed:', err);
    }
  };

  useEffect(() => {
    if (forgorSuccess) {
      // navigate("/account")
      setTimeout(() => navigate(`/passwordReset?email=${encodeURIComponent(email)}`), 1)
    }
  }, [forgorSuccess])

  return (
    <div className="">
      <div className='unityHeader'>
        <div className="login-header-image"><img src={headerImage}></img></div>
      </div>
      <div className='prettyLogin'>
        <div className="formContainer">
          <div className='header'>
            <h1>{t("header.welcome", "Welcome Back!").toUpperCase()}</h1>
          </div>
          <Form onSubmit={handleSubmit} >
            <Form.Group controlId="formEmail" className='formInput'>
              <Form.Control
                type="email"
                placeholder={t("email.placeholder", "Email Address")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isSuccess}
              />
            </Form.Group>

            <Form.Group controlId="formPassword" className='formInput'>
              <Form.Control
                type="password"
                placeholder={t("password.placeholder", "Password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isSuccess}
              />
            </Form.Group>
            <Button variant="primary" type="submit" disabled={isLoading} className='loginButton'>
              {isLoading || forgorLoading ? <Spinner animation="border" size="sm" /> : t("button.login", 'Login')}
            </Button>

            
            {forgerror && lastTried === "forgor" && <Alert variant="danger">{t("alert.forgotfail", "Password reset failed! Please check the email you entered is correct.")}</Alert>}
            {forgorSuccess && lastTried === "forgor" && <Alert variant="success">{t("alert.forgotSucceed", "Password reset started! Please follow the instructions sent to your email.")}</Alert>}
       
            {error && lastTried === "login" && <Alert variant="danger">{t("alert.fail", "Login failed!")}</Alert>}
            {isSuccess && lastTried === "login" && <Alert variant="success">{t("alert.success", "Successfully logged in!")}</Alert>}
          </Form>
        </div>
        <div className='bottomPrettyContent formContainer'>
        
          <div className='forgotPassword'>
          <Button variant="primary" type="submit" disabled={isLoading} className='loginButton'
            onClick={handleForgor}>
              {isLoading || forgorLoading ? <Spinner animation="border" size="sm" /> : t("forgot.password", "Forgot Password?")            }
            </Button>
            <Button variant="primary" type="submit" disabled={isLoading} className='loginButton' onClick={(e) => {
            e.preventDefault();
            navigate("/accountCreate")
          }}>
              {isLoading || forgorLoading ? <Spinner animation="border" size="sm" /> : t("createaccount", "Create new account")            }
            </Button>
          </div>
          {/* <div className='l' onClick={(e) => {
            e.preventDefault();
            navigate("/accountCreate")
          }}>
            <div>
            
              {t("noAccount", "Don't have an account?")}
            </div>
            <div>
              {}
            </div>
          </div> */}
        </div>

      </div>
      <div className='footerContent'>

      </div>

    </div>
  );
};

export default Login;